import { Address } from "./address";
import { BaseEntity, MemoizeGetters, toEntity, Transform } from "./base";

@MemoizeGetters
export class UserAddress extends BaseEntity {
  @Transform(toEntity(Address))
  address: Address;
}